module.exports = __webpack_public_path__ + "static/WillBud-folder-OJPIII-WWW_pages-to-jpg-0002-7b5086ce1cf085ad54b590aed830799d.jpg";